import React, { useState } from 'react';

import { NamedLink } from '../../../../components';
import dummyListingImage from '../../../../assets/Website Profile Placeholder Banners-02.jpg'

import css from '../../PartnerPortal.module.css';

const MAIN_BUCKET_NAME = process.env.REACT_APP_GCS_MAIN_BUCKET_NAME;
const GCS_URL = process.env.REACT_APP_GCS_URL;

const getImageUrl = (fileId) => `${GCS_URL}/${MAIN_BUCKET_NAME}/${fileId}`;

const ArrowIcon = () => {
  return (
    <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 2.13322C1 1.81135 1.12 1.49288 1.355 1.26735C1.77501 0.863881 2.40601 0.923948 2.76401 1.40108L13.0001 15.1111L23.2362 1.40109C23.5942 0.923949 24.2252 0.863882 24.6462 1.26735C25.0682 1.67309 25.1192 2.38709 24.7642 2.86536L13.7641 17.5988C13.5731 17.8538 13.2941 18 13.0001 18C12.7061 18 12.4271 17.8538 12.2361 17.5988L1.236 2.86536C1.078 2.65229 1 2.39162 1 2.13322Z" fill="#C3C3C3"/>
      <path fill="#C3C3C3" d="M1 2.13322C1 1.81135 1.12 1.49288 1.355 1.26735C1.77501 0.863881 2.40601 0.923948 2.76401 1.40108L13.0001 15.1111L23.2362 1.40109C23.5942 0.923949 24.2252 0.863882 24.6462 1.26735C25.0682 1.67309 25.1192 2.38709 24.7642 2.86536L13.7641 17.5988C13.5731 17.8538 13.2941 18 13.0001 18C12.7061 18 12.4271 17.8538 12.2361 17.5988L1.236 2.86536C1.078 2.65229 1 2.39162 1 2.13322" stroke="#C3C3C3" strokeWidth="1.93164"/>
    </svg>
  )
}

const RightArrowIcon = () => {
  return (
    <svg className={css.rightArrowIcon} width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.59994 14C1.42954 14 1.26094 13.935 1.14154 13.8077C0.927937 13.5802 0.959738 13.2384 1.21234 13.0445L8.47059 7.49995L1.21234 1.95541C0.959738 1.76149 0.927937 1.41969 1.14154 1.19165C1.35634 0.963066 1.73434 0.935441 1.98754 1.12773L9.7876 7.08611C9.9226 7.18957 10 7.3407 10 7.49995C10 7.6592 9.9226 7.81033 9.7876 7.91379L1.98754 13.8722C1.87474 13.9577 1.73674 14 1.59994 14Z" fill="#FCFCFC"/>
      <path fill="#FCFCFC" d="M1.59994 14C1.42954 14 1.26094 13.935 1.14154 13.8077C0.927937 13.5802 0.959738 13.2384 1.21234 13.0445L8.47059 7.49995L1.21234 1.95541C0.959738 1.76149 0.927937 1.41969 1.14154 1.19165C1.35634 0.963066 1.73434 0.935441 1.98754 1.12773L9.7876 7.08611C9.9226 7.18957 10 7.3407 10 7.49995C10 7.6592 9.9226 7.81033 9.7876 7.91379L1.98754 13.8722C1.87474 13.9577 1.73674 14 1.59994 14" stroke="#FCFCFC"/>
    </svg>
  )
}

const PremiumPartnerTiles = ({premiumPartners, intl}) => {
  const [maxElements, setMaxElements] = useState(8);

  const handleShowMore = () => {
    if (premiumPartners.length > maxElements) {
      setMaxElements(premiumPartners.length);
    }
  };

  const showExpandBtn = premiumPartners.length > maxElements;

  return (
    <div>
      <ul className={css.imagesList}>
        {premiumPartners.slice(0, maxElements).map(({attributes, id}) => {
          const {
            brandDetails: {
              companyDescription,
              banner = [],
              headerBanner = [],
            } = {},
            companyLegalName,
          } = attributes?.profile?.publicData ?? {};

          const imageExist = headerBanner[0] ?? banner[0];

          return (
            <NamedLink key={id.uuid} name="ProfilePage" params={{id: id.uuid}} className={css.imagesListItem}>
              <li className={css.imagesListItemInner}>
                {imageExist
                  ? <img src={getImageUrl(headerBanner[0] ?? banner[0])} alt="banner" className={css.img} />
                  : <div className={css.banner}>
                    <img src={dummyListingImage}  />
                  </div>}
                <div className={css.bannerDescription}>
                  <span className={css.companyLegalName}>{companyLegalName}</span>
                  <div className={css.bannerDivider} />
                  <span className={css.bio}>{companyDescription}</span>
                </div>

                <div className={css.rightArrowIconWrapper}>
                  <RightArrowIcon />
                </div>
              </li>
            </NamedLink>
          )
        })}
      </ul>
      {showExpandBtn ? <div className={css.btnContainer}>
        <div onClick={handleShowMore} className={css.showMoreBtn}>
          <span className={css.viewMoreBtn}>{intl.formatMessage({ id: 'PartnerPortal.viewMoreBtn' })}</span>
          <ArrowIcon />
        </div>
      </div> : null}
    </div>
  )
}

export default PremiumPartnerTiles;
